import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './AINewsAggregator.css';

interface NewsStory {
  title: string;
  url: string;
  hn_url: string;
  points: number;
  comments: number;
  signal_score: number;
}

interface AINewsData {
  generated_at: string;
  daily: {
    stories: NewsStory[];
  };
}

const AINewsAggregator: React.FC = () => {
  const [news, setNews] = useState<AINewsData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/ai-news.json')
      .then(res => res.json())
      .then(data => {
        setNews(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const topStories = news?.daily?.stories?.slice(0, 3) || [];

  return (
    <section id="ai-news-agg" className="ai-news-agg-section">
      <div className="container">
        <h2 className="section-title">AI News Aggregator</h2>
        <p className="section-description">
          Automated daily digest of high-signal AI news, filtered from Hacker News, Lobsters, Dev.to, Google News, and ArXiv.
        </p>
        
        {loading ? (
          <div className="news-loading">Loading today's news...</div>
        ) : topStories.length > 0 ? (
          <div className="news-preview">
            <h3 className="preview-title">Today's Top Stories</h3>
            <ul className="preview-list">
              {topStories.map((story, index) => (
                <li key={index} className="preview-item">
                  <a href={story.url || story.hn_url} target="_blank" rel="noopener noreferrer">
                    {story.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="news-loading">No news available yet.</div>
        )}
        
        <div className="agg-cta">
          <Link to="/ai-news-aggregator" className="agg-link">
            View Full Report
          </Link>
          <Link to="/demos" className="agg-link secondary">
            View Demos
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AINewsAggregator;
